/**
 * Share
 */

import Config from '../Config';
import UIKIT from 'uikit-utils';

class Share {
	private $shareButton: string;

	constructor() {
		this.$shareButton =  `#ncShare`;
		this.init();
	}

	private init() {
		( Config.isMobileSdk ) ?
			this.setMobileSdk() :
			this.setWeb();
	}

	private setMobileSdk() {
		jQuery( this.$shareButton ).on( 'click', ( evt ) => {
			evt.preventDefault();
			location.href = Config.mobileSdk.articleShare();
			return;
		});
	}

	private setWeb() {
		if (Config.isShare) {
            const share = new UIKIT.Share();
            share.init();
		}
	}
}

export default Share;
